import { useSelector } from "../../../hooks";
import styles from "./ScoreBar.module.scss";

export const ScoreBar = () => {
    const score = useSelector(store => store.tasks.joinChannelTasks?.penalty?.score) ?? 0;

    return (
        <div className={styles.container}>
            <div className={styles.progressBar}>
                <div
                    className={styles.progressFill}
                    style={{ width: `${100 - score * 100}%` }}
                />
            </div>
            
            <div className={styles.labels}>
                <span className={styles.labelLeft}>Ужасно</span>
                <span className={styles.labelRight}>Отлично</span>
            </div>
        </div>
    );
}